import { ReactNode } from "react";
import "./AppContentTitles.css";

interface AppContentTitlesProps {
  title: string;
  description: string;
  children?: ReactNode;
}

export default function AppContentTitles({
  title,
  description,
  children,
}: AppContentTitlesProps) {
  return (
    <div className="app-content-titles">
      <div className="app-content-titles-top">
        <h2>{title}</h2>
        {children}
      </div>
      <p>{description}</p>
    </div>
  );
}
